globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Account = appCustomerSpace.Controllers.Account || {};

appCustomerSpace.Controllers.Account.AccountController = (function(superClass) {

    utils.extend(AccountController, superClass);

    function AccountController() {
      return AccountController.__super__.constructor.apply(this, arguments);
    }

    $.extend(AccountController.prototype, {
      init: function(){
        return AccountController.__super__.init.apply(this, arguments);
      },
      edit: function() {
        var controller = this,
        $selectOrganizationType = controller.$body.find("select#account_organization_type"),
        $selectCompanySize      = controller.$body.find("select#account_company_size"),
        $selectAssociationSize  = controller.$body.find("select#account_association_size"),
        $selectActivityCategory = controller.$body.find("select#account_lead_activity_category");

        $selectOrganizationType.on("change", function(){
          var $this = $(this),
              val = $this.val();

          $selectCompanySize.prop("disabled", true).closest(".form-group").hide();
          $selectAssociationSize.prop("disabled", true).closest(".form-group").hide();
          $selectActivityCategory.closest(".form-group").fadeIn();

          switch(val) {
            case "individual":
              $selectActivityCategory.val("other").closest(".form-group").hide();
            break;
            case "company":
              $selectCompanySize.prop("disabled", false).closest(".form-group").fadeIn("fast");
            break;
            case "association":
              $selectAssociationSize.prop("disabled", false).closest(".form-group").fadeIn("fast");
              $selectActivityCategory.val("association").closest(".form-group").hide();
            break;
            case "public_entity":
              $selectActivityCategory.val("public_entity").closest(".form-group").hide();
            break;
          }
        });

        var $lifecyclestage = controller.$body.find("input[name='contact[account_attributes][lifecycle_stage]']"),
            $sales_rep = controller.$body.find("select#contact_account_attributes_closing_sales_rep_id");

        $lifecyclestage.on("change", function(){
          var $this = $(this),
              val = $this.val();

          switch(val) {
            case "sql":
              $sales_rep.closest(".form-group").fadeIn();
            break;
            case "lead":
              $sales_rep.closest(".form-group").fadeOut();
            break;
          }
        });
      }
    })

    return AccountController;

})(appCustomerSpace.Controllers.Account.MainController);
